// 监测点
import httpRequest from '@/utils/request.js';

/**
 * 获取监测点列表
 */
export const getMonitorPoint = (params = {}) => httpRequest.httpGet({
    url: '/service/carrier/monitor/lst', params: {
        ...params
    }
})

// 保存当前选中的监测点
export const panelSave = (data)=>httpRequest.httpPost('/service/carrier/monitor/save',data);

// 批量勾选获取详细信息
export const getBatchCarrierInfo=(params = {})=>httpRequest.httpGet({
    url:'/service/carrier/monitor/getBatchCarrierInfo',
    params:{
    ...params
}});

export const getCarrierInfo = (carrierId)=> httpRequest.httpPost(`/service/carrier/monitor/getCarrierInfo/${carrierId}`);

export const getCarrierDetailList = (params = {})=>httpRequest.httpGet({
    url:'/service/carrier/monitor/getCarrierList',
    params:{
        ...params
    }
});

// 数据分析-获取已保存的监测点列表
export const getSaved = ()=>httpRequest.httpGet({
    url:'/service/carrier/analyse/getData',
})

// 数据分析- 保存监测点
export const analSavePoint=(data)=> httpRequest.httpPost(`/service/carrier/analyse/saveData`,data);
// 数据分析 - 异常分析
export const exAnal= (params = {})=>httpRequest.httpGet({
    url:'/service/carrier/analyse/getDataAnalysis/ex',
    params:{
        ...params
    }
})

// 数据分析 分析设置保存
export const analSettingSave=(data)=>httpRequest.httpPost(`/service/carrier/analyse/saveSetting`,data);

// 数据分析 获取监测点状态
export const analPointStatus=(data)=>httpRequest.httpPost(`/service/carrier/analyse/getStatus`,data);
// 数据分析 获取正常异常比例分析
export const analProportion=(params={})=>httpRequest.httpGet({
    url:`/service/carrier/analyse/getDataAnalysis/normalAbnormal`,
    params,
})

// 获取监测点设置
export const getAnalSetting=(params={})=>httpRequest.httpGet({
    url:`/service/carrier/analyse/getSetting`,
    params
})

// 获取报警触发分析
export const alarmAnal= (params = {})=>httpRequest.httpGet({
    url:`/service/carrier/analyse/getDataAnalysis/alarm`,
    params,
})

// 获取监测点类型
export const analPointType=(data)=>httpRequest.httpPost(`/service/carrier/analyse/getType`,data);